import { Box, useTheme } from '@material-ui/core';
import LinkPreview from '@src/components/LinkPreview';
import { DARK_BG_CARD } from '@src/muithemes/darkModeColors';
import { checkPossibleUrl, setShowUrlPreview } from '@src/reducers/urlPreview';
import { activeWrittenMessageSelector } from '@src/selectors/chats';
import { getShowUrlPreview, urlAlreadyExist } from '@src/selectors/urlPreview';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const LinkPreviewWrapper: React.FC = () => {
  const dispatch = useDispatch();
  const isDark = useTheme().palette.type === 'dark';

  const activeWrittenMessage = useSelector(activeWrittenMessageSelector);
  const showUrlPreview = useSelector(getShowUrlPreview);
  const exist = useSelector(
    urlAlreadyExist(activeWrittenMessage.trim().split(' ')[0])
  );

  useEffect(() => {
    if (!exist && activeWrittenMessage.startsWith('http'))
      dispatch(checkPossibleUrl(activeWrittenMessage));

    if (showUrlPreview && activeWrittenMessage.length === 0)
      dispatch(setShowUrlPreview(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeWrittenMessage, showUrlPreview, exist]);

  useEffect(() => {
    if (exist && !showUrlPreview) dispatch(setShowUrlPreview(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exist, showUrlPreview]);

  if (!showUrlPreview) return null;

  return (
    <Box
      style={{
        zIndex: 1000,
        position: 'absolute',
        left: '17px',
        right: '0',
        bottom: '105%',
        width: '97%',
        backgroundColor: isDark ? DARK_BG_CARD : '#f4f4f5',
        borderRadius: '8px',
        boxShadow: '0px 16px 24px 0px #0000003d',
      }}
    >
      <LinkPreview
        url={activeWrittenMessage}
        showButton
        onClosePreview={() => dispatch(setShowUrlPreview(false))}
      />
    </Box>
  );
};

export default LinkPreviewWrapper;
